import {
  INPATIENT,
  INPATIENT_PLUS,
  OBSERVATION,
  OBSERVATION_PLUS,
} from '../constants/MeLValues.constants';

export const sortByMeL = (a, b) => {
  const order = [
    null,
    INPATIENT,
    INPATIENT_PLUS,
    OBSERVATION,
    OBSERVATION_PLUS,
  ];

  return order.indexOf(a) - order.indexOf(b);
};
